import { render, staticRenderFns } from "./product_selector.vue?vue&type=template&id=c26532b4&scoped=true"
import script from "./product_selector.vue?vue&type=script&lang=js"
export * from "./product_selector.vue?vue&type=script&lang=js"
import style0 from "./product_selector.vue?vue&type=style&index=0&id=c26532b4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26532b4",
  null
  
)

export default component.exports